import { DIALOGUE_CLUB_TEMPLATE_SLUGS, DIALOGUE_EVENT_TEMPLATE_SLUG } from '@/queries/constants'

export function isDialogueClub(seriesTemplateSlug: string): boolean {
  return DIALOGUE_CLUB_TEMPLATE_SLUGS.includes(seriesTemplateSlug)
}

export function isDialogueEvent(seriesTemplateSlug: string) {
  return seriesTemplateSlug === DIALOGUE_EVENT_TEMPLATE_SLUG
}

export function isDialogueSeries(seriesTemplateSlug: string): boolean {
  return isDialogueEvent(seriesTemplateSlug) || isDialogueClub(seriesTemplateSlug)
}
